// Imports
import { ComponentWrapper, Container } from "@/components";

function EspressoRose({ className = "size-12" }) {
  return (
    <div
      className={`bg-brand-espresso ${className}`}
      aria-hidden
      style={{
        maskImage: "url(/brand/ras-rose.svg)",
        WebkitMaskImage: "url(/brand/ras-rose.svg)",
        maskSize: "contain",
        WebkitMaskSize: "contain",
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskPosition: "center",
      }}
    />
  );
}

// Placeholder
export function Placeholder({ type, className, isLarge = true }) {
  switch (type) {
    case "image-placeholder":
      return (
        <div
          className={`${className} flex justify-center items-center w-full h-full ${
            isLarge ? "min-h-[200px]" : ""
          }  bg-brand-wool`}
        >
          <EspressoRose className="size-12 sm:size-14" />
        </div>
      );
    default:
      return (
        <ComponentWrapper type={type}>
          <Container>
            <div className="w-full text-white text-center flex justify-center items-center rounded-lg h-[300px] bg-brand-wool">
              <h2 className="text-center level-3">
                This is a {type} component!
              </h2>
            </div>
          </Container>
        </ComponentWrapper>
      );
  }
}
